import { IMakeColumnOption, ColumnType, Column } from "./type";
import { Checkbox, Icon } from "@blueprintjs/core";
import { CellWrap } from "./Styles";
import currency from "currency.js";

const converColumn = (column: Column, index?: number): ColumnType => {
  const {
    field,
    title,
    width: size,
    maxWidth: maxSize,
    minWidth: minSize,
    enableResize,
    enablePinning,
    enableSorting,
    enableColumnFilter,
    enableGrouping,
    titleRender,
    footerRender,
    render,
    sortingFn,
  } = column;

  const cellRender: typeof render = ({ row, cell, getValue }) => {
    let value = getValue();
    if (typeof value === "number") value = currency(value).value;
    if (!cell.getIsGrouped()) return value;
    return (
      <CellWrap depth={row.getIsExpanded() ? 0 : 0}>
        {row.getCanExpand() && (
          <Icon
            onClick={row.getToggleExpandedHandler()}
            icon={row.getIsExpanded() ? "chevron-down" : "chevron-right"}
            size={18}
          />
        )}
        {value as any}
      </CellWrap>
    );
  };
  return {
    accessorKey: field,
    header: titleRender ?? title,
    size,
    maxSize,
    minSize,
    sortingFn: sortingFn ?? "auto",
    cell: render ?? cellRender,
    footer: footerRender ?? "",
    enableResizing: enableResize,
    enablePinning: enablePinning,
    enableSorting: enableSorting,
    enableColumnFilter: enableColumnFilter,
    enableGrouping: enableGrouping,
  };
};
export const makeColumn = ({
  columns,
  selected,
  actions,
}: IMakeColumnOption): ColumnType[] => {
  const newColumn = Array.from(columns).map<ColumnType>(converColumn);

  if (selected) {
    newColumn.unshift({
      accessorKey: "select",
      enableResizing: false,
      size: 30,
      header: ({ table }) => (
        <Checkbox
          className="!mb-0"
          checked={table.getIsAllRowsSelected()}
          indeterminate={table.getIsSomeRowsSelected()}
          onChange={table.getToggleAllRowsSelectedHandler()}
        />
      ),
      cell: ({ row }) => {
        if (row.getCanSelect()) {
          return (
            <Checkbox
              className="!mb-0"
              checked={row.getIsSelected()}
              indeterminate={row.getIsSomeSelected()}
              onChange={row.getToggleSelectedHandler()}
            />
          );
        }
        return null;
      },
    });
  }
  // 空白占位符，避免 table 根据 fixed 自动拉伸所有单元格
  newColumn.push({
    accessorKey: "whitespace-placeholder",
    size: 100000,
    header: "",
    cell: "",
    footer: "",
    enableResizing: false,
    enablePinning: false,
    enableSorting: false,
    enableGrouping: false,
    enableColumnFilter: false,
  });

  if (actions) {
    if (typeof actions === "function") {
      newColumn.push({
        accessorKey: "actions",
        header: "",
        enableSorting: false,
        cell: (info) => {
          return actions(info.row.original);
        },
      });
    } else {
      newColumn.push(
        converColumn({
          enableResize: false,
          enableSorting: false,
          enableGrouping: false,
          enableColumnFilter: false,
          ...actions,
          field: "actions",
        })
      );
    }
  }
  return newColumn;
};
